"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _EditDescription = _interopRequireDefault(require("./EditDescription"));
var styles = {
  "description": "Description__description__1J5NF"
}; 
require('./Description.css');
var Description = function Description(_ref) {
  var description = _ref.description,
    _ref$isDisabled = _ref.isDisabled,
    isDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled,
    _ref$isEditing = _ref.isEditing,
    isEditing = _ref$isEditing === void 0 ? false : _ref$isEditing,
    _ref$onEditDescriptio = _ref.onEditDescription,
    onEditDescription = _ref$onEditDescriptio === void 0 ? function () {} : _ref$onEditDescriptio;
  if (isEditing || isDisabled) {
    return /*#__PURE__*/_react.default.createElement(_EditDescription.default, {
      description: description,
      isDisabled: isDisabled,
      onEditDescription: onEditDescription
    });
  }
  if (!description) {
    return null;
  }
  return /*#__PURE__*/_react.default.createElement("span", {
    "data-test-id": "version-agnostic-information-description",
    className: styles.description
  }, description);
};
var _default = exports.default = Description;
//# sourceMappingURL=Description.js.map